import { useMachine } from '@xstate/react'
import { requestMachine } from 'machines/requestMachine'
import { useLocationsActions } from 'providers'
import { useCallback } from 'react'
import { CreateLocationProps, TeachingLocation } from 'types/location'

export const useCreateLocation = (): [
  (locationData: CreateLocationProps) => void,
  TeachingLocation | undefined,
  boolean,
  string
] => {
  const [state, send] = useMachine(requestMachine)
  const { create: createLocation } = useLocationsActions()

  const create = useCallback(
    (locationData: CreateLocationProps) => {
      const promise = createLocation(locationData)
      send('SET_PROMISE', { data: promise })
    },
    [send, createLocation]
  )

  const createdLocation = state.matches('success') && state.context.data
  const errorMessage = state.matches('failed') ? state.context.error : ''
  const loading = state.matches('syncing')

  return [create, createdLocation, loading, errorMessage]
}
